// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2o2nH","actions":"GroupTable_actions__3PTvd","deleteModalFooter":"GroupTable_deleteModalFooter__39Hqk"};